module.exports = __webpack_public_path__ + "files/24b6fff12002ad5a09464ccfe1768997.png";